<template>
  <div id="custom_table">
    <b-table-simple
      table-class="custom_table board"
      ref="customtable"
      :hover="hover"
      responsive
    >
      <slot name="header"></slot>
      <slot name="body"></slot>
    </b-table-simple>
    <b-pagination-nav
      :link-gen="linkGen"
      :number-of-pages="totalPage"
      v-model="currentPage"
      use-router
      align="center"
      class="custom_pagination"
      first-class="goto"
      last-class="goto"
      next-class="goto"
      prev-class="goto"
      page-class="page_btn"
      size="sm"
      hide-ellipsis
      limit="10"
    >
      <template v-slot:first-text>
        <b-icon-chevron-double-left />
      </template>
      <template v-slot:prev-text>
        <b-icon-chevron-left />
      </template>
      <template v-slot:next-text>
        <b-icon-chevron-right />
      </template>
      <template v-slot:last-text>
        <b-icon-chevron-double-right />
      </template>
    </b-pagination-nav>
  </div>
</template>

<script>
import {
  BIconChevronDoubleLeft,
  BIconChevronLeft,
  BIconChevronRight,
  BIconChevronDoubleRight,
} from "bootstrap-vue";

export default {
  components: {
    BIconChevronDoubleLeft,
    BIconChevronLeft,
    BIconChevronRight,
    BIconChevronDoubleRight,
  },
  props: {
    totalPage: {
      type: Number,
      default: 1,
    },
    curPage: {
      type: Number,
      default: 1,
    },
    hover: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentPage: this.curPage,
      numberOfPages: parseInt(this.totalPage),
    };
  },
  methods: {
    linkGen(pageNum) {
      // console.log(pageNum, this.$route.path, this.$route.query, this.$route,this.$route.hash)
      return `?page=${pageNum}` + this.$route.hash;
    },
  },
};
</script>

<style></style>
